import React, { Component, createElement } from "react";
import { connect } from "react-redux";
import Button from "../../../../shared/button/button";
import Card from "../../../../shared/Card/Card";
import AdvancedManagementBoxTimeDate from "../template/AdvancedManagementBoxTimeDate";
import { bindActionCreators } from "redux";
import moment from "moment";
import { onSendDocuments } from "../../../actions/advanced-management";
import Loading from "../../../../shared/Loading/Loading";
import { setStep, getRelationships } from "../../../actions/advanced-management";

class AdvancedManagementDocumentsSent extends Component {
	constructor(props) {
		super(props);
		this.state = { alreadyCalledApprove: false };
	}

	getDateAndTime() {
		return {
			date: moment().format("DD/MM/YYYY"),
			time: moment().format("HH:mm:ss")
		};
	}

	goHome = () => {
		this.props.getRelationships();
		this.props.setStep(1);
	};

	approveInvite() {
		this.props.onSendDocuments({
			...this.props.dataToSendDocuments
		});
		this.setState({ alreadyCalledApprove: true });
	}

	render() {
		const { isLoading, sendingFile } = this.props;
		const { alreadyCalledApprove } = this.state;
		if (isLoading.onSendDocuments || sendingFile) {
			return (
				<Loading
					className="loading-component--documents-send"
					label="Por favor, aguarde enquanto os arquivos são enviados."
				/>
			);
		} else if (!alreadyCalledApprove) {
			this.approveInvite();
		}
		let data = this.props.dataRelationship.find(
			data => data.participant.idusers === this.props.dataToSendDocuments.idParticipant
		);
		let invite = this.getDateAndTime();

		return (
			<div>
				<Card withoutMargin className="advanced-management-documents-sent">
					<div className="text-center advanced-management-documents-sent--box">
						<div className="text-center advanced-management-documents-sent--box--header">
							<h4>
								<strong>Documentos enviados para análise</strong>
							</h4>
							<p className="advanced-management-documents-sent--box--header-status-description">
								A partir de agora, os documentos enviados por você e pelo participante serão
								analisados pela equipe da MaxMilhas. Esse processo pode levar{" "}
								<strong>até 7 dias corridos</strong> e você poderá acompanhar todas as alterações de
								status por aqui.
							</p>
						</div>
						<div className="text-center advanced-management-documents-sent--box--info">
							<div className="advanced-management-documents-sent--box--info--icon">
								<i className="icon-check" />
							</div>

							<div className="row">
								<div className="col-xs-16 text-left">
									<strong>Em análise</strong>
									<span className="advanced-management-documents-sent--subtitle">
										<br />Em análise pela MaxMilhas
									</span>
								</div>
							</div>

							<div className="row offers-divider offers-divider--title advanced-management-documents-sent--divider-margin" />

							<div className="row advanced-management-documents-sent--row-data">
								<div className="col-xs-16 col-lg-4 text-left advanced-management-documents-sent--box--info-name">
									<div className="d-flex flex-row advanced-management-documents-sent--box--info-name-align-items-baseline">
										<div className="advanced-management-documents-sent--box--info-name-flex-attr">
											Nome
										</div>
										<div className="advanced-management-documents-sent--box--info-name-flex-value">
											<strong>{data.participant.name}</strong>
										</div>
									</div>
								</div>
								<div className="col-xs-16 col-lg-4 text-left advanced-management-documents-sent--box--info-name">
									<div className="d-flex flex-row advanced-management-documents-sent--box--info-name-align-items-baseline">
										<div className="advanced-management-documents-sent--box--info-name-flex-attr">
											Cidade
										</div>
										<div className="advanced-management-documents-sent--box--info-name-flex-value">
											<strong>{data.participant.city}</strong>
										</div>
									</div>
								</div>
								<div className="col-xs-16 col-lg-4 text-left advanced-management-documents-sent--box--info-name">
									<div className="d-flex flex-row advanced-management-documents-sent--box--info-name-align-items-baseline">
										<div className="advanced-management-documents-sent--box--info-name-flex-attr">
											CPF
										</div>
										<div className="advanced-management-documents-sent--box--info-name-flex-value">
											<strong>{data.participant.ssn}</strong>
										</div>
									</div>
								</div>
								<AdvancedManagementBoxTimeDate
									date={invite.date}
									time={invite.time}
									screen="desktop"
								/>
							</div>
							<AdvancedManagementBoxTimeDate
								date={invite.date}
								time={invite.time}
								screen="mobile"
							/>
						</div>
						<div className="col-md-16 text-center advanced-management-documents-sent--box--ok">
							<div className="advanced-management-documents-sent--box--ok-button">
								<Button className="btn-primary-lg" onClick={this.goHome}>
									Ok
								</Button>
							</div>
						</div>
					</div>
				</Card>
			</div>
		);
	}
}

const mapStateToProps = state => ({
	...state.advancedManagement,
	sendingFile: state.advancedManagement.sendingFile
});

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
			setStep,
			getRelationships,
			onSendDocuments
		},
		dispatch
	);

export default connect(mapStateToProps, mapDispatchToProps)(AdvancedManagementDocumentsSent);
